module.exports = __webpack_public_path__ + "black.c68bca99.jpg";